module.exports = __webpack_public_path__ + "static/media/3-check.f833c842.svg";